<div class="voltage-report-table">
  <div class="voltage-report-table-heading">
    <div>
      <h2>نوسانات غیرعادی ولتاژ</h2>
      <p>تفکیک جهش لحظه‌ای و نوسان پایدار</p>
    </div>
    <div class="segment voltage-report-table-controls" role="group" aria-label="نوع نوسان ولتاژ">
      <button class="seg-btn" type="button" [class.active]="filter === 'all'" [attr.aria-pressed]="filter === 'all'" (click)="setFilter('all')">همه</button>
      <button class="seg-btn" type="button" [class.active]="filter === 'transient'" [attr.aria-pressed]="filter === 'transient'" (click)="setFilter('transient')">لحظه‌ای</button>
      <button class="seg-btn" type="button" [class.active]="filter === 'persistent'" [attr.aria-pressed]="filter === 'persistent'" (click)="setFilter('persistent')">پایدار</button>
    </div>
  </div>

  <div class="table-scroll" tabindex="0" role="region" aria-label="جدول نوسانات غیرعادی ولتاژ">
    <table>
      <thead><tr>
        <th scope="col">زمان</th>
        <th scope="col">نوع رویداد</th>
        <th scope="col">ولتاژ</th>
        <th scope="col">مدت</th>
        <th scope="col">اختلاف با الگو</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let row of visibleRows">
          <td>
            <span class="num" [title]="row.startDate + ' – ' + row.endDate">{{ row.start }}</span>
          </td>
          <td><span class="tag" [class.bad]="row.persistent === true" [class.warn]="row.persistent === false">{{ row.persistent === true ? 'پایدار' : row.persistent === false ? 'لحظه‌ای' : 'نامشخص' }}</span></td>
          <td class="num"><ng-container *ngIf="row.min !== null; else unavailable">{{ row.min | number:'1.2-2':'en-US' }}<ng-container *ngIf="row.max !== row.min"> – {{ row.max | number:'1.2-2':'en-US' }}</ng-container> V</ng-container></td>
          <td class="num">{{ row.duration }}</td>
          <td class="num"><ng-container *ngIf="row.deviation !== null; else unavailable">{{ row.deviation | number:'1.2-2':'en-US' }} σ</ng-container></td>
        </tr>
        <tr *ngIf="!visibleRows.length"><td colspan="5" class="voltage-report-table-empty" role="status">{{ rows.length ? 'رویدادی در این گروه ثبت نشده است.' : 'نوسان غیرعادی ولتاژ برای این روز گزارش نشده است.' }}</td></tr>
      </tbody>
    </table>
  </div>
  <app-table-pagination *ngIf="filteredRows.length > 10" [page]="page" [pageSize]="pageSize" [totalItems]="filteredRows.length" [pageSizeOptions]="[10, 20, 50]" (pageChange)="setPage($event)" (pageSizeChange)="setPageSize($event)"></app-table-pagination>
  <p class="voltage-report-table-note">فاصله از الگو به‌صورت قدر مطلق انحراف معیار نمایش داده می‌شود. مدت، بازهٔ مشاهده‌شدهٔ رخداد است.</p>
</div>
<ng-template #unavailable>—</ng-template>
